export default "__VITE_ASSET__DKkdVhLB__"